/**
 * The `PageWrapper` component is used to render a page, catch any potential issues (e.g.,
 * Authorization errors) and act accordingly by showing an alert or redirecting to another page.
 *
 */

import React from 'react';
import { RouteComponentProps } from 'react-router';

export type PageWrapperChildrenProps = RouteComponentProps;

export type PageWrapperProps = RouteComponentProps;

// TODO
export class PageWrapper extends React.Component<PageWrapperProps> {
  public componentDidCatch(e: any, i: any) {
    console.log('WRAPPER DID CATCH');
    console.log(e);
    console.log(i);
  }

  public render() {
    let { children } = this.props;

    try {
      return <>{children}</>;
    } catch (e) {
      return <h1>Error</h1>;
    }
  }
}

export default PageWrapper;
